/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TapeLibraryMoveEndpointRequest
 */
export interface TapeLibraryMoveEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof TapeLibraryMoveEndpointRequest
     */
    barcode: string;
    /**
     * 
     * @type {number}
     * @memberof TapeLibraryMoveEndpointRequest
     */
    slot: number;
}

export function TapeLibraryMoveEndpointRequestFromJSON(json: any): TapeLibraryMoveEndpointRequest {
    return TapeLibraryMoveEndpointRequestFromJSONTyped(json, false);
}

export function TapeLibraryMoveEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TapeLibraryMoveEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'barcode': json['barcode'],
        'slot': json['slot'],
    };
}

export function TapeLibraryMoveEndpointRequestToJSON(value?: TapeLibraryMoveEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'barcode': value.barcode,
        'slot': value.slot,
    };
}


